import { render, staticRenderFns } from "./list.vue?vue&type=template&id=fca2d1f0&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=fca2d1f0&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=fca2d1f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2d1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca2d1f0')) {
      api.createRecord('fca2d1f0', component.options)
    } else {
      api.reload('fca2d1f0', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=fca2d1f0&scoped=true", function () {
      api.rerender('fca2d1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/archives/list.vue"
export default component.exports